/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StarterServicesDto
 */
export interface StarterServicesDto {
    /**
     * 
     * @type {number}
     * @memberof StarterServicesDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof StarterServicesDto
     */
    serviceId?: number;
    /**
     * 
     * @type {number}
     * @memberof StarterServicesDto
     */
    quantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StarterServicesDto
     */
    cancelRequest?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StarterServicesDto
     */
    starterId?: number;
}

/**
 * Check if a given object implements the StarterServicesDto interface.
 */
export function instanceOfStarterServicesDto(value: object): value is StarterServicesDto {
    return true;
}

export function StarterServicesDtoFromJSON(json: any): StarterServicesDto {
    return StarterServicesDtoFromJSONTyped(json, false);
}

export function StarterServicesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StarterServicesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'serviceId': json['serviceId'] == null ? undefined : json['serviceId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'cancelRequest': json['cancelRequest'] == null ? undefined : json['cancelRequest'],
        'starterId': json['starterId'] == null ? undefined : json['starterId'],
    };
}

export function StarterServicesDtoToJSON(json: any): StarterServicesDto {
    return StarterServicesDtoToJSONTyped(json, false);
}

export function StarterServicesDtoToJSONTyped(value?: StarterServicesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'serviceId': value['serviceId'],
        'quantity': value['quantity'],
        'cancelRequest': value['cancelRequest'],
        'starterId': value['starterId'],
    };
}

